import { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AUTH_ROUTE } from "../../../pages/App/routes";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../../../store";
import { setShowNotVerifiedErrorAction } from "../../../store/auth/slice";

const ErrorRedirect: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const stepCompletion = useSelector(
    (state) => state.onboarding.completedstatus
  );

  useEffect(() => {
    const isErrorPage = location.pathname === "/error";
    const params = new URLSearchParams(location.search);
    const message = params.get("message");
    
    if(
      message?.includes("Authentication failed") || 
      message === "Authentication failed: Missing required callback parameters" || 
      message === "End-User aborted interaction" ||
      message === "Invalid state parameter" || 
      message === "End-User aborted"
    ) {
      dispatch(setShowNotVerifiedErrorAction(true))
    }

    if (isErrorPage) {
      if (stepCompletion !== null && stepCompletion?.personal_details === 1) {
        navigate(AUTH_ROUTE.MY_PROFILE);
      } else {
        navigate(AUTH_ROUTE.ID_VERIFICATION);
      }
    }
  }, [location, navigate, stepCompletion]);

  return null;
};

export default ErrorRedirect;